import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
export const TrialActivatedAlert = () => {
    const { t } = useTranslation();
    return _jsx("div", { className: 'alert alert-primary clearfix', role: 'alert', "data-testid": 'trial-activated', children: _jsxs(Trans, { i18nKey: 'trialActivated', values: { siteName: t('siteName') }, children: ["Splendid, your ", _jsxs("strong", { children: [t('siteName'), " PRO"] }), " 14 day trial is activated! Now you can analyze your ", _jsx("strong", { children: "private repositories" }), ". Happy code review."] }) });
};
